import { styled } from '../theme';
import ListItem from './ListItem';

const ListItemTop = styled(ListItem)(({ theme }) => ({
    borderBottom: theme.border.tableRowSeparator,
    borderRadius: 0,
    borderTopLeftRadius: theme.borderRadius.base,
    borderTopRightRadius: theme.borderRadius.base,
}));

export default ListItemTop;
